import { toast } from 'sonner';

export const QUEUE_ROUTES = {
  pharmacy: '/workflow/pharmacy-queue',
  lab: '/workflow/lab-queue',
  imaging: '/workflow/imaging-queue',
  reception: '/workflow/reception-closure',
};

const QUEUE_LABELS = { pharmacy: 'Pharmacy', lab: 'Lab', imaging: 'Imaging', reception: 'Reception' };

const queueToast = (msg) => {
  const label = QUEUE_LABELS[msg.queue_type] || 'Queue';
  const d = msg.data || {};
  const item = d.item || d.test_name || d.prescription_id || 'item';
  switch (msg.action) {
    case 'completed':
      return { kind: 'success', title: `${item} completed`, description: `${d.patient_name} · by ${d.completed_by || 'staff'}` };
    case 'closed':
      return { kind: 'success', title: 'Case closed', description: `${d.patient_name} checked out${d.total_amount != null ? ` · ₹${Number(d.total_amount).toFixed(2)}` : ''}` };
    case 'opted_out':
      return { kind: 'warning', title: 'Case force-closed', description: `${d.patient_name} opted out · ${label} queue updated` };
    default:
      return {
        kind: 'info',
        title: `New in ${label} queue`,
        description: d.test_name ? `${d.test_name} · ${d.patient_name}` : `${d.patient_name}${d.reason ? ` · ${d.reason}` : ''}`,
      };
  }
};

const patientToast = (msg) => {
  const d = msg.data || {};
  const name = d.full_name || d.patient_name || 'Patient';
  switch (msg.event) {
    case 'registered':
      return { kind: 'info', title: 'New patient registered', description: `${name}${d.patient_id ? ` · ${d.patient_id}` : ''}`, route: '/patients' };
    case 'admitted': {
      const bed = [d.room_number && `Room ${d.room_number}`, d.bed_number && `Bed ${d.bed_number}`].filter(Boolean).join(' · ');
      return { kind: 'info', title: 'Patient admitted', description: `${name}${bed ? ` · ${bed}` : ''}`, route: '/admissions' };
    }
    case 'discharged':
      return { kind: 'success', title: 'Patient discharged', description: name, route: '/admissions' };
    default:
      return null;
  }
};

const show = ({ kind, title, description, route }, navigate, currentPath) => {
  const fn = toast[kind] || toast.info;
  const onSamePage = route && currentPath === route;
  fn(title, {
    description,
    duration: 6000,
    action: route && !onSamePage ? { label: 'View', onClick: () => navigate(route) } : undefined,
  });
};

/** Turn a live WebSocket event into a toast (queue changes, admissions, billing, appointments). */
export const toastForLiveEvent = (msg, navigate, currentPath) => {
  if (msg.type === 'queue_update') {
    show({ ...queueToast(msg), route: QUEUE_ROUTES[msg.queue_type] }, navigate, currentPath);
    return;
  }
  if (msg.type === 'patient_event') {
    const t = patientToast(msg);
    if (t) show(t, navigate, currentPath);
    return;
  }
  if (msg.type === 'billing_event' && msg.event === 'created') {
    show({ kind: 'info', title: 'New bill created', description: `${msg.data.patient_name} · ₹${Number(msg.data.total_amount || 0).toFixed(2)}`, route: '/billing' }, navigate, currentPath);
    return;
  }
  if (msg.type === 'appointment_event' && msg.event === 'created') {
    show({ kind: 'info', title: 'New appointment', description: `${msg.data.patient_name} with Dr. ${msg.data.doctor_name}`, route: '/appointments' }, navigate, currentPath);
  }
};
